import React, { createContext, useContext, useState } from 'react'
import { Storage } from '../../utils.jsx'
import { AccessTime, VisibilityOff, Window } from '@mui/icons-material'

export const GameModeContext = createContext()

export function GameModeProvider({ children }) {
  const gameModes = {
    Standard: {
      icon: <Window sx={{ paddingRight: '8px' }} />,
      4: { type: 'standard4', description: '4 Letters', disabled: false },
      5: {
        type: 'standard5',
        description: '5 Letters',
        disabled: false,
      },
    },
    Timed: {
      icon: <AccessTime sx={{ paddingRight: '8px' }} />,
      4: {
        type: 'timed4',
        description: '4 Letters (Coming Soon!)',
        disabled: true,
      },
    },
    Blind: {
      icon: <VisibilityOff sx={{ paddingRight: '8px' }} />,
      4: {
        type: 'blind4',
        description: '4 Letters (Coming Soon!)',
        disabled: true,
      },
    },
  }

  const isModeAvailable = (mode) =>
    Object.values(gameModes).some((modeGroup) =>
      Object.values(modeGroup).some(
        (gameDetails) =>
          gameDetails.type === mode && !gameDetails.disabled,
      ),
    )

  const [gameMode, setGameMode] = useState(() => {
    const savedGameMode = Storage.getFromLocalStorage('gameMode')
    const initialGameMode = isModeAvailable(savedGameMode)
      ? savedGameMode
      : 'standard4'

    Storage.saveToLocalStorage('gameMode', initialGameMode)
    return initialGameMode
  })

  const changeGameMode = (mode) => {
    if (isModeAvailable(mode)) {
      setGameMode(mode)
      Storage.saveToLocalStorage('gameMode', mode)
    }
  }

  const getAvailableGameModes = () => {
    return gameModes
  }

  return (
    <GameModeContext.Provider
      value={{
        gameMode,
        changeGameMode,
        getAvailableGameModes,
      }}
    >
      {children}
    </GameModeContext.Provider>
  )
}

export function useGameMode() {
  const context = useContext(GameModeContext)
  if (!context) {
    throw new Error('useGameMode must be used within a GameModeProvider')
  }
  return context
}
